<!-- =========================================================================================
    File Name: UserDevicePopup.vue
    Description: Device details in user page
========================================================================================== -->
<template>
  <div>
    <vs-popup :title="$t('DEVICE_INFORMATION')" :active.sync="isDevicePopupActiveLocal">
      <vs-list>
        <vs-list-header icon-pack="feather" icon="icon-video" :title="$t('DEVICE_INFORMATION')"></vs-list-header>
          <vs-list-item :title="$t('DEVICE_UUID')" >
            {{userInfo.device.deviceUUID}}
          </vs-list-item>

          <vs-list-item :title="$t('USER_ID')" >
              {{userInfo.user.userId}}
          </vs-list-item>

          <vs-list-item :title="$t('DEVICE_STATUS')" >
            <vs-chip :color="getDeviceStatusColor(userInfo.device.deviceStatus)">
              {{$t(setDeviceStatusName(userInfo.device.deviceStatus))}}
            </vs-chip>
          </vs-list-item>

          <vs-list-item :title="$t('SERVICE_STATUS')" >
            <vs-chip :color="getServiceStatusColor(userInfo.device.serviceStatus)">
              {{$t(setServiceStatusName(userInfo.device.serviceStatus))}}
            </vs-chip>
          </vs-list-item>

          <vs-list-item :title="$t('USED_SUBSCRIBE_STATUS')" >
            <vs-chip :color="getUsedSubscribeColor(userInfo.device.usedSubscribe)">
              {{$t(setUsedSubscribeName(userInfo.device.usedSubscribe))}}
            </vs-chip>
          </vs-list-item>

          <vs-list-item :title="$t('LAST_CONNECTED_TIME')" >
              {{setLocalTime(userInfo.device.lastConnectedTime)}}
          </vs-list-item>

          <vs-list-item :title="$t('PROMOTION_START_DATETIME')" >
              {{setLocalTime(userInfo.device.promotionStartDateTime)}}
          </vs-list-item>
      </vs-list>

      <vs-divider/>

      <div class="float-right">
        <vs-button type="border" color="danger" @click.stop="isDevicePopupActiveLocal = false"  >{{$t('CLOSE')}}</vs-button>
      </div>

    </vs-popup>
  </div>
</template>

<script>

export default {
  data() {
    return {
                
    }
  },
  props: {
    isDevicePopupActive: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.dataUser.userInfo
    },
    isDevicePopupActiveLocal: {
      get() {
        return this.isDevicePopupActive
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
  },
  methods: {
    getDeviceStatusColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.deviceStatus.properties[status].color
    },
    setDeviceStatusName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.deviceStatus.properties[status].name
    },
    getServiceStatusColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.serviceStatus.properties[status].color
    },
    setServiceStatusName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.serviceStatus.properties[status].name
    },
    getUsedSubscribeColor(status) {
      if (status === "") return "primary"
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].color
    },
    setUsedSubscribeName(status){
      if (status === "") return ""
      return this.$store.state.commonConfig.usedSubscriptionStatus.properties[status].name
    },
    setLocalTime(time){
      if(!time){
        return '-'
      }else {
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let dateTime = this.$moment(time,'YYYYMMDDHHmmss').format()
        let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
        return dateTimeToLocal
      }
    },
  }
}

</script>